import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { LoaderService } from '@loup-transload-ui-app/common-services';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-shared-loader',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  standalone: true,
  imports: [CommonModule],
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  @if(loaderService.loading$ | async){
    <div class="loader-container">
        <div class="loader-content">
            <up-progress-indicator class="bluish" indeterminate [percent]="30"></up-progress-indicator>
            <p class="loader-text">Please wait...</p> 
        </div>
    </div>
  }`,
})

export class LoaderComponent {
  constructor(public loaderService: LoaderService) {}
  
}
